import React from 'react';

export default function ProductBox({ product, buttonDisabled, link }) {
  return (
    <div className='w-full sm:w-[48%] md:w-[30%] lg:w-[30%] flex flex-col items-center justify-center'>
      <div className='p-1 w-4/5 mb-4 h-fit text-white text-center'>
        <label className='text-[30px] sm:text-[30px] md:text-[35px] lg:text-[35px]'>
          {product.name}
        </label>
      </div>
      <div
        key={product.name}
        className='flex flex-col text-white border-2 border-yellow-500 h-[400px] mb-5 w-full'
      >
        <div
          style={{
            backgroundImage: `url("/images/${product.image}")`,
          }}
          className='bg-cover bg-no-repeat bg-center flex justify-center items-end w-full h-full'
        ></div>
      </div>
      <button
        disabled={buttonDisabled}
        onClick={() => {
          if (!buttonDisabled && link && link.startsWith('https')) {
            window.open(link, '_blank', 'noopener,noreferrer'); // Opens the link in a new tab
          }
        }}
        className={`slavic-font mt-5 uppercase text-white text-lg md:text-xl py-2 px-6 md:px-8 rounded-lg tracking-wider ${
          buttonDisabled
            ? 'border-2 border-gray-500'
            : 'bg-gradient-to-r hover:from-yellow-500 hover:to-yellow-800 border-2 border-yellow-500'
        }`}
      >
        {buttonDisabled ? 'Ускоро' : 'Поручи'}
      </button>
    </div>
  );
}
